import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { AppyUser } from 'src/app/core/model/v2/AppyUser';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { CaseDocument } from '../../models/caseDocument';
import { Case } from '../../models/casehistory';

@Component({
  selector: 'case-documents',
  templateUrl: './case-documents.component.html',
  styleUrls: ['./case-documents.component.scss']
})
export class CaseDocumentsComponent implements OnInit {
  @Input() caseModel: Case;
  @Output() toggleEvent = new EventEmitter();
  caseDocuments:CaseDocument[]=[];
  user:AppyUser=new AppyUser();
  constructor(private caseManagementService: CaseManagementService,
    public dialog: MatDialog,
    private userService:UserService,
    private loaderService: WindowLoaderService,) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (x) => { this.user = x; },
      (error) => { console.error(error); });
    this.getCaseDocuments();
  }
attachFile(event) {
      let file: File;
    if (event[0]) {
      file = event[0];
    } else {
      file = event.target.files[0];
    }
      this.caseManagementService
      .uploadCaseDocument(
        this.caseModel.id,
        file
      )
      .subscribe((res) =>{
       if(res.resultStatus.isSuccess){
        //this.caseDocuments.concat(res.result)
        this.getCaseDocuments();
       }else{

      }});
  }

  getCaseDocuments() {
    this.loaderService.show();
    this.caseManagementService
      .getCaseDocuments(
        this.caseModel.id
      )
      .subscribe((res) => {
        this.caseDocuments=res.result;
        this.loaderService.hide();

      }, (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
  }
  deleteCaseDocument(docId:number){
    this.caseManagementService
      .deleteCaseDocument(
        docId
      )
      .subscribe((res) =>{
       if(res.resultStatus.isSuccess){
        
        this.getCaseDocuments();
       }else{

      }});
  }
  viewFile(doc: CaseDocument) {
    const dialogRef = this.dialog.open(CaseDocDialogOverview, {
      id: "view-dialog",
      height: 'auto',
      maxHeight: '100vh',
      maxWidth:'100vw',
      hasBackdrop: true,
      data: doc
    });
}
}
@Component({
  selector: 'dialog-overview-example-dialog',
  template: `<div mat-dialog-content class="p-0 m-0 mat-dialogmh">
              <iframe id="casedocviewer" type="text/html" width="100%" [src]='showDoc()' style="height: 85vh; width:90vw"
                      frameborder="0" allowfullscreen></iframe>
            </div>
            <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
 
</mat-dialog-actions>`
})
export class CaseDocDialogOverview {

  constructor(
    public dialogRef: MatDialogRef<CaseDocDialogOverview>,
    @Inject(MAT_DIALOG_DATA) public data: CaseDocument,
    private sanitizer: DomSanitizer) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showDoc() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.data.documentUrl);
  }

}
